/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    RpConfigDTO,
    RpConfigDTOFromJSON,
    RpConfigDTOToJSON,
} from '../models';

/**
 * 
 */
export class RpConfigControllerApi extends runtime.BaseAPI {

    /**
     */
    async getConfigRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<RpConfigDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/rp/config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RpConfigDTOFromJSON(jsonValue));
    }

    /**
     */
    async getConfig(initOverrides?: RequestInit): Promise<RpConfigDTO> {
        const response = await this.getConfigRaw(initOverrides);
        return await response.value();
    }

}
